import { cooKeys, getCookie } from "goi_common";

const QUOTATION_RESUBMIT_SESSION_KEY = "quotation_resubmit";

/**
 * 견적 제출이 성공한 직후, 응답을 쿠키에 덮어쓰기 **전에** 호출한다. 두 신호를 OR 로 합쳐
 * "이번 제출이 재제출인가"를 판정해 세션스토리지에 남긴다.
 *
 * - **쿠키가 이미 있었나** — 같은 브라우저에서 전에 제출한 적이 있다는 뜻. 비회원과
 *   로그아웃한 재방문자를 잡는다. 대신 로그인 상태로만 제출해온 회원은 못 잡는다.
 *   제출 퍼널 일부가 `isLoggedIn` 이면 쿠키 쓰기를 건너뛰어 쿠키가 아예 안 쌓이기 때문.
 * - **응답이 200인가** — v2 는 `회원 + 기존 견적 있음` 에만 200(merge)을 주고 최초 제출은
 *   비회원·회원 모두 201 이다(`apis/sangjoQuotation.ts` 참고). 위에서 놓친 회원을 잡는다.
 *   대신 RT 만료·로그아웃·1차가 비회원 제출인 경우는 못 잡는데, 그건 쿠키 쪽이 메운다.
 *
 * 두 신호 다 "이전 제출이 있었다"는 사실만 말하므로 OR 로 합쳐도 false positive 는 없고
 * 커버리지만 넓어진다. 여전히 못 잡는 건 기기·브라우저 교체와 쿠키 삭제뿐이다.
 *
 * **호출 지점은 `useSangjoQuotationRequests` 의 제출 성공 콜백 한 곳뿐이다.**
 * 쿠키를 직접 쓰는 다른 호출부들(`AllQuotationRequestButtonGroup`, `MatchCompareDetailRequest`,
 * `useHandleSendMemoAndRedirectToLogin` 등)에는 **절대 넣지 말 것** — 그쪽은 제출이 아니라
 * 제출 직후의 memo PATCH 응답을 쿠키에 다시 쓰는 후속 단계라, 그 시점엔 같은 흐름에서 방금
 * 쓴 쿠키가 항상 존재한다. 거기서 판정하면 최초 제출자가 전부 재제출로 뒤집힌다.
 */
export function markQuotationResubmit(responseStatus: number): void {
  const hadPreviousCookie = Boolean(getCookie(cooKeys.quotation_request));
  const isMergedByServer = responseStatus === 200;

  try {
    sessionStorage.setItem(
      QUOTATION_RESUBMIT_SESSION_KEY,
      hadPreviousCookie || isMergedByServer ? "true" : "false",
    );
  } catch {}
}

/** markQuotationResubmit 이 남긴 판정 읽기. 없으면 안전하게 false. */
export function isQuotationResubmit(): boolean {
  try {
    return sessionStorage.getItem(QUOTATION_RESUBMIT_SESSION_KEY) === "true";
  } catch {
    return false;
  }
}
